import { Slideshow } from "./../Slideshow/handler";

jQuery(window).on("elementor/frontend/init", () => {
  elementorFrontend.hooks.addAction(
    "frontend/element_ready/wfg-header-slider-buchbinde.default",
    ($element) => {
      elementorFrontend.elementsHandler.addHandler(Slideshow, {
        $element,
      });
    },
  );
});

